<template>
  <div class="installations">
    <div class="installations__header">
      <div class="installations__header-left">
        <p>
          <strong>
            {{ $t('regional-manager.editing.installations.header-title') }}
          </strong>
        </p>
        <p>
          <strong>{{ $t('regional-manager.editing.installations.header-warning') }}</strong>
          {{ $t('regional-manager.editing.installations.header-message') }}.
        </p>
      </div>
      <div class="installations__header-right">
        <s-search-input
          class="installations__search-input"
          v-model="searchTerm"
          :placeholder="$t('general.search')"
        />
      </div>
    </div>
    <s-table
      :fields="fields"
      :items="filtered"
      :busy="loading"
      local-sorting
      class="installations__installations-table no-align"
    >
      <template #head(check)>
        <div class="installations__check-wrapper">
          <b-form-checkbox @click.native.stop :checked="allSelected" @change="toggleAll"/>
        </div>
      </template>
      <template #cell(check)="data">
        <b-form-checkbox v-model="data.item.selected" />
      </template>
    </s-table>
  </div>
</template>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .installations
    &__installations-table ::v-deep
      tbody
        display: block
        max-height: 430px
        overflow: auto
      tbody, thead
        tr
          display: table
          width: 100%
          table-layout: fixed
    &__loader
      font-size: 2em
      margin-bottom: 1em
    &__header
      display: flex
      margin-bottom: 8px
      flex-direction: column
    &__header-left
      flex: 1
      padding-left: 8px
      p
        margin-bottom: 0.4rem
    &__header-right
      align-self: flex-end
      width: 100%
    &__check-wrapper
      display: flex
    &__search-input
      height: 100%
    ::v-deep &__cell
      &-check
        width: 40px
      &-name
        text-align: center
    +media-min-sm()
      &__header
        flex-direction: row
      &__header-right
        width: auto
</style>


<script>
import RegionalEditService from '@/domain/services/generalPanel/adminPanel/regional/regionalEditService';

export default {
  name: 'Installations',
  props: { regional: Object },
  data() {
    return {
      searchTerm: '',
      loading: true,
      installations: [],
    };
  },
  methods: {
    toggleAll(checked) {
      this.installations.forEach((it) => {
        it.selected = checked;
      });
    },
    fillInstallationsGrid() {
      const actualSelection = this.regional.installations.filter(({ selected }) => selected);
      RegionalEditService
        .getInstallationsWithoutRegionalByCompanyId(this.regional.companyId)
        .then((installations) => {
          this.installations = [
            ...this.getOldInstallationsByCompany(),
            ...installations,
          ].map(installation => ({
            ...installation,
            selected: actualSelection
              .some(({ id: regionalInstallationId }) => regionalInstallationId === installation.id),
          }))
            .sort((a, b) => a.name.localeCompare(b.name));
          this.loading = false;
        });
    },
    refreshRegionalInstallations() {
      if (this.loading) {
        return;
      }
      this.regional.installations = this.installations;
    },
    getOldInstallationsByCompany() {
      if (this.regional.companyId !== this.regional.$originalCompanyId) {
        return [];
      }

      return this.regional.$originalInstallations;
    },
  },
  computed: {
    allSelected() {
      return this.filtered.every(it => it.selected);
    },
    fields() {
      const prefix = 'profile-manager.editing.installations';

      return [
        { key: 'check', class: 'installations__cell-check' },
        {
          key: 'name',
          class: 'installations__cell-name',
          label: this.$t(`${prefix}.installation`),
          sortable: true,
        },
      ];
    },
    selection() {
      return this.installations.filter(it => it.selected);
    },
    filtered() {
      return this.installations.filter(it => (
        it.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      ));
    },
  },
  created() {
    this.fillInstallationsGrid();
  },
  watch: {
    selection() {
      this.refreshRegionalInstallations();
    },
  },
};
</script>
